import React, { useState, useEffect } from "react"
import {
  Container,
  Card,
  CardBody,
  Input,
  Row,
  Col,
  Label,
  Form,
  Button,
  FormGroup,
  InputGroup,
  InputGroupText,
  FormFeedback,
  Alert,
} from "reactstrap"
import axios from "axios"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const QuerySubmit = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    app_query: "",
    files: null,
    app_info: "",
  })

  const [urlParams, setUrlParams] = useState({ version: "", platform: "" })
  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const version = urlSearchParams.get("version") || ""
    const platform = urlSearchParams.get("platform") || ""

    setUrlParams({ version, platform })

    const appInfo = version || platform ? `${version}, ${platform}` : ""

    setFormData(prev => ({
      ...prev,
      app_info: appInfo,
    }))
  }, [])

  const handleInputChange = e => {
    const { name, value, files } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: files ? files[0] : value,
    }))

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: "",
      }))
    }
  }

  const validateForm = () => {
    const newErrors = {}
    if (!formData.name.trim()) newErrors.name = "Name is required"
    if (!formData.email.trim()) {
      // newErrors.email = "Email is required"
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email"
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone is required"
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone"
    }
    if (!formData.files) {
      newErrors.files = "Attachment is required"
    }
    if (!formData.app_query.trim()) {
      newErrors.app_query = "Query is required"
    } else if (formData.app_query.length < 10) {
      newErrors.app_query = "Query should be at least 10 characters"
    }
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (!validateForm()) return

    setIsSubmitting(true)

    try {
      const payload = new FormData()
      payload.append("name", formData.name)
      payload.append("email", formData.email)
      payload.append("phone", formData.phone)
      payload.append("app_query", formData.app_query)
      payload.append("bucketName", "topschool-attachments")
      payload.append("app_info", formData.app_info)
      payload.append("files", formData.files)

      const response = await axios.post(
        "https://marcopolo.prisms.in/api/tscommon/support-query",
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )

      if (response?.data) {
        toast.success("Query submitted successfully")
        setShowSuccess(true)
      }

      setFormData({
        name: "",
        email: "",
        phone: "",
        app_query: "",
        files: null,
        app_info: formData.app_info,
      })
    } catch (err) {
      console.error("Error submitting form", err)
      toast.error("Submission failed. Please try again.")
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Container
      fluid
      className="py-4 px-3"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      <Row className="justify-content-center">
        <Col xs={12} md={8} lg={6} xl={5} className="mb-4">
          <Card className="shadow-lg border-0" style={{ borderRadius: "5px" }}>
            <div
              className="text-center py-4"
              style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
              }}
            >
              <i className="bx bx-support fs-1 mb-2"></i>
              <h2 className="mb-1 fw-bold fs-4 fs-md-3">Submit Your Query</h2>
            </div>

            <CardBody className="p-4">
              {showSuccess && (
                <Alert color="success" className="mb-4 border-0 shadow-sm">
                  <i className="bx bx-check-circle me-2"></i>
                  Your query has been submitted successfully!
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <FormGroup className="mb-4">
                  <Label for="name" className="text-dark">
                    Full Name <span className="text-danger">*</span>
                  </Label>
                  <InputGroup>
                    <InputGroupText>
                      <i className="bx bx-user"></i>
                    </InputGroupText>
                    <Input
                      type="text"
                      name="name"
                      id="name"
                      placeholder="Enter your name"
                      value={formData.name}
                      onChange={handleInputChange}
                      invalid={!!errors.name}
                    />
                    <FormFeedback>{errors.name}</FormFeedback>
                  </InputGroup>
                </FormGroup>

                <FormGroup className="mb-4">
                  <Label for="phone" className="text-dark">
                    Mobile Number <span className="text-danger">*</span>
                  </Label>
                  <InputGroup>
                    <InputGroupText>
                      <i className="bx bx-phone"></i>
                    </InputGroupText>
                    <Input
                      type="tel"
                      maxLength={10}
                      name="phone"
                      id="phone"
                      placeholder="Enter your phone number"
                      value={formData.phone}
                      onChange={handleInputChange}
                      invalid={!!errors.phone}
                    />
                    <FormFeedback>{errors.phone}</FormFeedback>
                  </InputGroup>
                </FormGroup>

                <FormGroup className="mb-4">
                  <Label for="email" className="text-dark">
                    Email
                  </Label>
                  <InputGroup>
                    <InputGroupText>
                      <i className="bx bx-envelope"></i>
                    </InputGroupText>
                    <Input
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleInputChange}
                      invalid={!!errors.email}
                    />
                    <FormFeedback>{errors.email}</FormFeedback>
                  </InputGroup>
                </FormGroup>

                <FormGroup className="mb-4">
                  <Label for="app_query" className="text-dark">
                    Your Query <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="textarea"
                    name="app_query"
                    id="app_query"
                    rows="4"
                    placeholder="Describe your query"
                    value={formData.app_query}
                    onChange={handleInputChange}
                    invalid={!!errors.app_query}
                  />
                  <FormFeedback>{errors.app_query}</FormFeedback>
                </FormGroup>

                <FormGroup className="mb-4">
                  <Label for="files" className="text-dark">
                    Attach Screenshot of your query{" "}
                    <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="file"
                    name="files"
                    id="files"
                    onChange={handleInputChange}
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.txt"
                    invalid={!!errors.files}
                  />
                  <FormFeedback>{errors.files}</FormFeedback>
                </FormGroup>

                <Button
                  type="submit"
                  color="primary"
                  block
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default QuerySubmit
